module.exports = "<template>${ value | date:'L' } <template if.bind=value>(${ 'sio.field.age' | t }: ${ _getAge(value) })</template></template> ";